import { useState } from 'react';
import './App.css';
import { AqDataTable } from './AqDataTable';
import { AqMap } from './map/AqMap';

function App() {
  const [showTable, setShowTable] = useState(false);

  return (
    <div className="App">
      <div>
        <AqMap />
        <div className="App-tableToggle">
          <button
            type="button"
            aria-expanded={showTable}
            aria-controls="aq-data-table"
            onClick={() => setShowTable((shown) => !shown)}
          >
            {showTable ? 'Hide station data' : 'Show station data'}
          </button>
        </div>
        {/* Mounted only when shown, so the table fetches its data on demand */}
        {showTable && (
          <div id="aq-data-table">
            <AqDataTable />
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
